import React from 'react';
import {OrbitComponent} from '../../base-components/orbit-component/orbit-component';
import {observer} from 'mobx-react';
import {ActiveFilter} from '../../../services/games-filter/games-filter.service.interface';
import {FilterLinkListComponent} from '../filter-link-list/filter-link-list.component';
import {FiltersGameListPcBox} from "./boxes/filters-game-list-pc.box";

@observer
export class FiltersGamesListPcComponent extends OrbitComponent<{}> {

  private _toggleFilter = (filter: ActiveFilter) => {
    let selectedFilter = this.services.gamesFilter.currentFilters.filter(currentFilter=> currentFilter.id === filter.id);
    this.services.gamesFilter.toggleFilter(filter.id);

    if(selectedFilter?.length === 1 && selectedFilter[0].on === false) {
      this.services.analytics.sendAnalytics("Navigation", this.services.routing.currentRoute.data.arenaType, filter.id);
    }
  };

  render() {
    if(this.services.device.isMobile) {
      return null;
    }

    let currentFilters = this.services.gamesFilter.currentFilters;
    if(currentFilters.length === 0) {
      return null;
    }

    return (
      <FiltersGameListPcBox className={'cy-filters-game-list-pc'}>
          <FilterLinkListComponent filters={currentFilters} onToggle={this._toggleFilter} />
      </FiltersGameListPcBox>
    );
  }
}
